exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".vhallPlayerh5-container .vhallPlayerh5-currenttime{\n  font-size: 12px;\n  color: #ffffff;\n  margin: 0 15px;\n}\n", ""]);
